import React from "react";

interface DocumentESignStatusProps {
  sender: server.dto.ESignParticipantProgress
  signer: server.dto.ESignParticipantProgress
}

const getDescription = (progress: server.dto.ESignParticipantProgress, isSigner: boolean) => {
  const role = isSigner ? RESX.ESign.Signer : RESX.ESign.Sender;
  switch (progress.value) {
    case "senderAutoSignActive":
      return isSigner ? RESX.ESign.SenderShouldSignFirst : RESX.ESign.SignerShouldSignFirst;
    case "automaticallyCompleted":
      return `${role} automatically signed`;
    case "manuallyCompleted":
      return `${role} manually completed`;
    case "signedByPerson":
      return `${role} has signed`;
    case "readyForSigning":
      return `${role} did not sign`;
    case "waitingForSigner":
      return `Waiting for ${RESX.ESign.Signer}`;
  }
};

const getIcon = (progress: server.dto.ESignParticipantProgress) => {
  switch (progress.value) {
    case "senderAutoSignActive":
      return <i className="icon-hourglass gray"></i>;
    case "automaticallyCompleted":
      return <i className="icon-check darkgreen"></i>;
    case "manuallyCompleted":
      return <i className="icon-check purple"></i>;
    case "signedByPerson":
      return <i className="icon-check green"></i>;
    case "readyForSigning":
      return <i className="icon-check gray"></i>;
    case "waitingForSigner":
      return <i className="icon-hourglass gray"></i>;
  }
};

const DocumentESignStatus = (props: DocumentESignStatusProps) => {
  return (
    <div className="flex margin-top-small align-center">
      <div style={{ width: 30, textAlign: "center" }} title={getDescription(props.sender, true)}>
        {getIcon(props.sender)}
      </div>
      <div style={{ width: 30, textAlign: "center" }} title={getDescription(props.signer, false)}>
        {getIcon(props.signer)}
      </div>
    </div>
  );
};

export default DocumentESignStatus;